import { useState, useRef, useEffect } from "react";
import { ThreeDotsVertical, ChevronDown, ChevronUp } from "react-bootstrap-icons";

import "./styles.css";

function Options({
    settings,
    onChangeHandler,
    disabled=false
}) {
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setExpanded(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const onChange = (section, key, type) => {
        onChangeHandler(section, key)

        switch (type) {
            case "button":
                setExpanded(false);
                break;
        }
    };

    return (
        <>
            { Object.keys(settings?.items ?? {}).length > 0 ? (
                <div
                    ref={ref}
                    className="menu-wrapper"
                >
                    <button
                        type="button"
                        className="btn options-btn rounded-circle p-2 d-flex align-items-center"
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={(e) => {
                            e.preventDefault();

                            if(!disabled){
                                setExpanded(prev => !prev);
                            }
                        }}
                    >
                        <ThreeDotsVertical size={22} className="ms-auto flex-shrink-0" />
                    </button>

                    {expanded && (
                        <ul className="list-group options-list">

                            {Object.entries(settings.items).map(([key, item])=> {


                                switch (item.type) {
                                    case 'switch':
                                        return (
                                            <li
                                                key={key}
                                                className="list-group-item d-flex justify-content-between align-items-center px-2"
                                            >
                                                <span>{item.label}</span>

                                                <div className="form-check form-switch options-switch m-0" >
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        style={{
                                                            cursor: "pointer"
                                                        }}
                                                        id={key}
                                                        checked={item.checked}
                                                        onChange={() => onChange(settings.section, key, item.type)}
                                                    />
                                                </div>
                                            </li>
                                        );
                                    case 'sort_switch':
                                        return (
                                            <li
                                                key={key}
                                                className="list-group-item d-flex justify-content-between align-items-center px-2"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => onChange(settings.section, key, item.type)}
                                            >
                                                <span>{item.label}</span>

                                                {item.value == 'asc'
                                                    ? <ChevronDown size={16} className="ms-auto me-2 flex-shrink-0" />
                                                    : <ChevronUp size={16} className="ms-auto me-2 flex-shrink-0" />
                                                }
                                            </li>
                                        );
                                    case 'button':
                                        return (
                                            <li
                                                key={key}
                                                className="list-group-item d-flex justify-content-between align-items-center px-2"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => onChange(settings.section, key, item.type)}
                                            >
                                                <span>{item.label}</span>
                                            </li>
                                        );
                                    case 'divider':
                                        return (
                                            <hr
                                                key={key}
                                                className="m-0 border-top border-2"
                                            />
                                        );
                                    default:
                                        return null
                                }
                            })

                            }                            
                        </ul>
                    )}
                </div>
            ) : null}
        </>
    );
};

export default Options;
